import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import * as React from 'react';

const WarningIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox='0 0 24 24' sx={{ height: '24px', width: '24px', ...sx }} {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.9967 3.00098C13.6735 3.00098 14.4929 4.22872 14.6702 4.53352L21.5341 16.3334C21.9964 17.1282 22.0826 18.0868 21.7696 18.9513C21.324 20.1814 20.1548 21.001 18.8453 21.001H5.14987C3.84033 21.001 2.67111 20.1814 2.22557 18.9513C1.91248 18.0868 1.99871 17.1282 2.46106 16.3334L9.32492 4.53352C9.51163 4.21253 10.32 3.00098 11.9967 3.00098ZM12.8413 8.9063C12.8413 8.44031 12.4635 8.06255 11.9975 8.06255C11.5315 8.06255 11.1538 8.44031 11.1538 8.9063V13.9688C11.1538 14.4348 11.5315 14.8126 11.9975 14.8126C12.4635 14.8126 12.8413 14.4348 12.8413 13.9688V8.9063ZM11.9976 18.1875C12.6189 18.1875 13.1226 17.6839 13.1226 17.0625C13.1226 16.4412 12.6189 15.9375 11.9976 15.9375C11.3763 15.9375 10.8726 16.4412 10.8726 17.0625C10.8726 17.6839 11.3763 18.1875 11.9976 18.1875Z'
        fill='#FF5F57'
      />
    </SvgIcon>
  );
};

export default WarningIcon;
